import { useTranslate } from "ra-core";
import { Button } from "@/components/ui/button";

import { CalendarSection } from "./CalendarSection";
import { MailboxSection } from "./MailboxSection";
import { SignatureSection } from "./SignatureSection";
import { useMailAccount, useMailAccountMutation } from "./useMailAccount";

/**
 * « Messagerie et agenda »: each user connects their Infomaniak mailbox and
 * calendar, and sets the signature of the emails sent from OPTICERCLE.
 */
export const MailSettingsPage = () => {
  const translate = useTranslate();
  const { data: account, isPending } = useMailAccount();
  const test = useMailAccountMutation(
    (dataProvider) => dataProvider.testMailAccount(),
    "crm.mail.tested",
  );
  const hasConnection =
    account?.mail_status !== "disconnected" ||
    account?.calendar_status !== "disconnected";

  return (
    <div className="max-w-3xl mx-auto mt-6 mb-10 flex flex-col gap-6 px-1">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold">
            {translate("crm.mail.title")}
          </h1>
          <p className="text-sm text-muted-foreground max-w-xl">
            {translate("crm.mail.intro")}
          </p>
        </div>
        {account && hasConnection ? (
          <Button
            type="button"
            variant="outline"
            disabled={test.isPending}
            onClick={() => test.mutate(undefined)}
          >
            {translate(test.isPending ? "crm.mail.checking" : "crm.mail.test")}
          </Button>
        ) : null}
      </div>
      {isPending ? null : (
        // Keyed by account id so the forms start from the saved values.
        <div key={account?.id ?? "new"} className="flex flex-col gap-6">
          <MailboxSection account={account ?? null} />
          <CalendarSection account={account ?? null} />
          <SignatureSection account={account ?? null} />
        </div>
      )}
    </div>
  );
};

MailSettingsPage.path = "/mail-settings";
